import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue'
import i18n from './i18n';

import './style.css'
import vuetify from './plugins/vuetify'
//import vuetify from './temaVuetify.js'; // Ruta al archivo con el tema
import { loadFonts } from './plugins/webfontloader'
import store from './store';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import PaginaHome from './components/PaginaHome.vue';
import PaginaLogin from './components/PaginaLogin.vue';
import ComponenteSimulacion from './components/ComponenteSimulacion.vue';
//import ComponenteResultadoSimulacion from './components/ComponenteResultadoSimulacion.vue';

import ComponenteSimulaciones from './components/ComponenteSimulaciones.vue';

import ComponentePrecios from './components/utilidades/ComponentePrecios.vue';
import ComponenteFuturos from './components/utilidades/ComponenteFuturos.vue';
import ComponentePrograma from './components/utilidades/ComponentePrograma.vue';

import ComponenteInformes from './components/informes/ComponenteInformes.vue';

import ComponenteMaestroRo from './components/maestros/ComponenteMaestroRo.vue';

loadFonts()

const routes = [
  { path: '/login', name: 'PaginaLogin', component: PaginaLogin },
  { path: '/', name: 'PaginaHome', component: PaginaHome, meta: { requiresAuth: true } ,
    children: [      
      { path: '/simulaciones', name: 'ComponenteSimulaciones', component: ComponenteSimulaciones, meta: { requiresAuth: true } },  
      { path: '/nueva-simulacion', name: 'ComponenteSimulacion', component: ComponenteSimulacion, meta: { requiresAuth: true } },  
      { path: '/resultado-simulacion/:id', name: 'ComponenteResultadoSimulacion', component: ComponenteSimulacion, meta: { requiresAuth: true }, props: true },  

      { path: '/precios', name: 'ComponentePrecios', component: ComponentePrecios, meta: { requiresAuth: true } },  
      { path: '/futuros', name: 'ComponenteFuturos', component: ComponenteFuturos, meta: { requiresAuth: true } },  
      { path: '/programa', name: 'ComponentePrograma', component: ComponentePrograma, meta: { requiresAuth: true } },  
      { path: '/informes', name: 'ComponenteInformes', component: ComponenteInformes, meta: { requiresAuth: true } },  

      { path: '/ro', name: 'ComponenteMaestroRo', component: ComponenteMaestroRo, meta: { requiresAuth: true } },  
    ]
  },  
];

const router = createRouter({
  history: createWebHistory(),  
  routes: routes,
});

const app = createApp(App)
app.use(i18n);


fetch('/config.json')
  .then((response) => response.json())
  .then((config) => {
   
    // Proveer la configuración globalmente
    app.provide('config', config);

  })
  .catch((error) => {
    console.error('Error loading configuration:', error);
  });


router.beforeEach((to, from, next) => {  

  document.title = to.meta.title || 'Viscosim';
  
  let faviconUrl = to.meta.favicon || '/favicon.ico';
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = faviconUrl;

  const isAuthenticated = store.state.usuarioAutenticado; 

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {             
    console.log("A Login")
    next('/login')
  } else {
    console.log("A Home")
    next()
  }
});





import VMdPreview from '@kangc/v-md-editor/lib/preview';

// highlightjs
import hljs from 'highlight.js';
import githubTheme from "@kangc/v-md-editor/lib/theme/github.js";
import '@kangc/v-md-editor/lib/theme/style/github.css'

// katex (fórmulas)
import createKatexPlugin from '@kangc/v-md-editor/lib/plugins/katex/npm';
import 'katex/dist/katex.min.css';

VMdPreview.use(githubTheme, {
  Hljs: hljs,
});
VMdPreview.use(createKatexPlugin());

//createApp(App)
app.use(VueSweetalert2);

app.use(router)
app.use(vuetify)
app.use(store)
app.component('VueDatePicker', VueDatePicker);
app.mount('#app')
app.use(VMdPreview);

   



